import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import { toRoman } from 'helpers'

import { Tooltip } from 'react-wot-bootstrap'
import StatsTable from 'components/StatsTable/StatsTable.jsx'

import { STATS_TOOLTIP_NO_STATS, STATS_TOOLTIPS_IDS } from './constants.jsx'

import styles from './StatsTooltip.scss'

export const StatsTooltip = props => {
    const { level, sorties, fort_battles } = props

    const hasSorties = sorties.battles_count
    const hasFortBattles = fort_battles && fort_battles.battles_count

    if (!hasSorties && !hasFortBattles) {
        return (
            <Tooltip id={STATS_TOOLTIPS_IDS[level]}>
                <div className={classNames(styles.base, styles.base__noBattles)}>
                    <p className={styles.tooltipMessage}>
                        {STATS_TOOLTIP_NO_STATS(toRoman(level))}
                    </p>
                </div>
            </Tooltip>
        )
    }

    return (
        <Tooltip id={STATS_TOOLTIPS_IDS[level]} isWide>
            <div className={styles.base}>
                <StatsTable {...props} />
            </div>
        </Tooltip>
    )
}

StatsTooltip.propTypes = {
    elo: PropTypes.number,
    level: PropTypes.string.isRequired,
    fort_battles: PropTypes.object,
    sorties: PropTypes.object.isRequired,
    elo_details: PropTypes.shape({
        position: PropTypes.number,
        battles_count: PropTypes.number,
        required_battles_count: PropTypes.number,
        recalculation_period: PropTypes.number,
    }),
}

export default StatsTooltip



// WEBPACK FOOTER //
// ./containers/Stronghold/components/StatsTooltip/StatsTooltip.jsx